<template>
  <div id="app">
    <v-app id="inspire">
      <template>
        <v-container class="grey lighten-5">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card class="pa-2" outlined tile color="green">
                PROCEDIMIENTOS
              </v-card>
            </v-col>
          </v-row>
          <v-row dense no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP4.01.01')">
                MP4.01.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP4.01.01')">
                Diseño, aprobación e implementación de los requisitos generales
                del SGI.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.01.01')">
                MP5.01.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.01.01')">
                Responsabilidad de la Dirección.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.01.02')">
                MP5.01.02
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.01.02')">
                Objetivos y metas
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.04.03')">
                MP5.04.03
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.04.03')">
                Programa SOL
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.05.01')">
                MP5.05.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.05.01')">
                Responsabilidad, autoridad, comunicación
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.06.01')">
                MP5.06.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP5.06.01')">
                Revisión por la Dirección
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP6.01.01')">
                MP6.01.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP6.01.01')">
                Suministro de recursos
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP6.01.02')">
                MP6.01.02
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP6.01.02')">
                Gestión de riesgos y oportunidades
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.01.01')">
                MP8.01.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.01.01')">
                Requisitos generales para la medición, análisis y mejora
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.03.01')">
                MP8.03.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.03.01')">
                Gestión de no conformidades
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.05.01')">
                MP8.05.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.05.01')">
                Gestión de mejoras
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.05.02')">
                MP8.05.02
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MP8.05.02')">
                Acciones correctivas
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card class="pa-2" outlined tile color="green">
                INSTRUCTIVOS
              </v-card>
            </v-col>
          </v-row>
          <v-row dense no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI4.02.01.01')">
                MI4.02.01.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI4.02.01.01')">
                Archivo general.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI4.02.01.02')">
                MI4.02.01.02
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI4.02.01.02')">
                Sistema de back-up y almacenamiento de datos.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.01')">
                MI5.04.02.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.01')">
                Formación de brigada contra incendios.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.02')">
                MI5.04.02.02
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.02')">
                Plan de emergencias.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.03')">
                MI5.04.02.03
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.03')">
                Atención de accidentes de trabajo.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.04')">
                MI5.04.02.04
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.04')">
                Primeros auxilios.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.05')">
                MI5.04.02.05
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI5.04.02.05')">
                Formación de brigada de emergencias y socorro.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI6.03.01.04')">
                MI6.03.01.04
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI6.03.01.04')">
                Señalizaciones.
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile @click="verInforme('MI8.01.01.01')">
                MI8.01.01.01
              </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile @click="verInforme('MI8.01.01.01')">
                Guía para la gestión de la economía de la calidad, medio
                ambiente y SST.
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <Visualizardocumentos :visible="this.showInforme" :codigo="this.codigo" :rutadoc="this.rutadoc"
        @close="showInforme = false">
      </Visualizardocumentos>
    </v-app>
  </div>
</template>
<script>
import Visualizardocumentos from "../SGI/Visualizardocumento.vue";
export default {
  data: (vm) => ({
    codigo: "",
    rutadoc: "",
    showInforme: false,
  }),
  components: { Visualizardocumentos },
  methods: {
    verInforme(codigo) {
      this.codigo = codigo;
      this.showInforme = true;
      console.log(this.codigo);
    },
  },
};
</script>
